import { render, staticRenderFns } from "./content.vue?vue&type=template&id=2720cd07&scoped=true&"
import script from "./content.vue?vue&type=script&lang=ts&"
export * from "./content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720cd07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2720cd07')) {
      api.createRecord('2720cd07', component.options)
    } else {
      api.reload('2720cd07', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=2720cd07&scoped=true&", function () {
      api.rerender('2720cd07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "core/plugin/toasts/vue/content.vue"
export default component.exports